import { errorToastQueueName } from "../configs/storageKeys.json";

function hasInternetConnection() {
	return window.navigator.onLine;
}
const localStorageName = "localStorage";
const sessionStorageName = "sessionStorage";

function saveToLocalStorage(key, value) {
	saveToStorage(localStorageName, key, value);
}

function loadFromLocalStorage(key) {
	return loadFromStorage(localStorageName, key);
}

function removeFromLocalStorage(key) {
	removeFromStorage(localStorageName, key);
}

function saveToSessionStorage(key, value) {
	saveToStorage(sessionStorageName, key, value);
}

function loadFromSessionStorage(key) {
	return loadFromStorage(sessionStorageName, key);
}

function removeFromSessionStorage(key) {
	removeFromStorage(sessionStorageName, key);
}

function saveToStorage(storageType, key, value) {
	if (
		isStorageAvailable[storageType] === true ||
		storageAvailable(storageType) === true
	) {
		try {
			if (typeof value === "object") {
				value = JSON.stringify(value);
			}

			window[storageType].setItem(key, value);
			return true;
		} catch (e) {
			console.error(`Save to ${storageType} Exception`, e, key, value);
			isStorageAvailable[storageType] = false;
			return false;
		}
	}
	return false;
}

function loadFromStorage(storageType, key) {
	if (
		isStorageAvailable[storageType] === true ||
		storageAvailable(storageType) === true
	) {
		try {
			let stringItem = window[storageType].getItem(key);

			let objectItem = null;

			try {
				objectItem = JSON.parse(stringItem);
			} catch {
				return stringItem;
			}

			if (typeof objectItem === "object" && objectItem !== null) {
				return objectItem;
			}

			return stringItem;
		} catch (e) {
			console.error(`Load from ${storageType} Exception`, e, key);
			return null;
		}
	}

	return null;
}

function removeFromStorage(storageType, key) {
	if (
		isStorageAvailable[storageType] === true ||
		storageAvailable(storageType) === true
	) {
		try {
			window[storageType].removeItem(key);
			return true;
		} catch (e) {
			console.error(`Remove from ${storageType} Exception`, e, key);
			return false;
		}
	}

	return false;
}

const isStorageAvailable = {
	localStorage: false,
	sessionStorage: false,
};

function storageAvailable(storageType) {
	let storage = null;
	try {
		storage = window[storageType];
		var testString = "__storage_test__";
		storage.setItem(testString, testString);
		storage.removeItem(testString);
		isStorageAvailable[storageType] = true;
	} catch (e) {
		const isAvailable =
			e instanceof DOMException &&
			// everything except Firefox
			(e.code === 22 ||
				// Firefox
				e.code === 1014 ||
				// test name field too, because code might not be present
				// everything except Firefox
				e.name === "QuotaExceededError" ||
				// Firefox
				e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
			// acknowledge QuotaExceededError only if there's something already stored
			storage &&
			storage.length !== 0;

		if (isAvailable === true) {
		} else {
			console.error(e);
		}
		isStorageAvailable[storageType] = isAvailable;
	}

	return isStorageAvailable[storageType];
}

const toastStorage = localStorageName;

function queueToast(toastMessage) {
	const msg =
		typeof toastMessage === "string"
			? toastMessage
			: JSON.stringify(toastMessage);
	saveToStorage(toastStorage, errorToastQueueName, msg);
}

function getToast() {
	let message = loadFromStorage(toastStorage, errorToastQueueName);

	try {
		message = JSON.parse(message);
	} catch (ex) {}

	removeFromStorage(toastStorage, errorToastQueueName);

	return message;
}

export {
	hasInternetConnection,
	saveToLocalStorage,
	loadFromLocalStorage,
	removeFromLocalStorage,
	saveToSessionStorage,
	loadFromSessionStorage,
	removeFromSessionStorage,
	queueToast,
	getToast,
};
